import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import LoginPage from './components/auth/LoginPage';
import LoginSuccess from './components/auth/LoginSuccess';
import LoginError from './components/auth/LoginError';
import Dashboard from './pages/Dashboard';
import { MyStudentsView, AllStudentsView, AddStudentView } from './components/students/StudentComponents';
import { SessionReports } from './components/sessions/SessionReports';
import AdminSection from './components/admin/AdminSection';  // Import the AdminSection component
import InvoicingDashboard from './components/invoicing/InvoicingDashboard';
import ManageRetreats from './components/admin/ManageRetreats';

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <div className="min-h-screen bg-slate-50">
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<LoginPage />} />
            <Route path="/login-success" element={<LoginSuccess />} />
            <Route path="/login-error" element={<LoginError />} />
            
            {/* Protected dashboard routes */}
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }>
              {/* Nested routes for dashboard */}
              <Route index element={<Navigate to="students/my-students" replace />} />
              <Route path="students/my-students" element={<MyStudentsView />} />
              <Route path="students/all" element={<AllStudentsView />} />
              <Route path="students/add" element={
                <ProtectedRoute allowedRoles={['admin', 'manager']}>
                  <AddStudentView />
                </ProtectedRoute>
              } />
              <Route path="reports">
                <Route index element={<Navigate to="view" replace />} />
                <Route path="create" element={<SessionReports.Create />} />
                <Route path="view" element={<SessionReports.View />} />
              </Route>
              <Route path="invoicing">
                <Route index element={
                  <ProtectedRoute allowedRoles={['admin', 'manager']}>
                    <InvoicingDashboard />
                  </ProtectedRoute>
                } />
                <Route path="retreats" element={
                  <ProtectedRoute allowedRoles={['admin', 'manager']}>
                    <ManageRetreats />
                  </ProtectedRoute>
                } />
              </Route>
              <Route path="admin/*" element={
                <ProtectedRoute requiredRole="admin">
                  <AdminSection />
                </ProtectedRoute>
              } />
            </Route>
            {/* Catch all redirect */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </AuthProvider>
    </QueryClientProvider>
  );
}

const DashboardHome = () => {
  return (
    <div className="p-4">
      <h1 className="text-base font-medium text-slate-700">Dashboard Home</h1>
    </div>
  );
};

export default App;